import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CommonModule } from '@angular/common';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


// Angular material components
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';


// Global variables
import { GlobalVariables } from '../../../../constants/global';

// Custom services 
import { LanguageService } from '../../../../services/language/language.service';
import { UtilsService } from '../../../../services/utils/utils.service';







/* Specify the structure of the dictionary that will receive the dialog when being openned */
export interface DialogData {additionalInformationDict:any}


@Component({
  selector: 'app-vertebral-levels-ad',
  standalone: true,
  imports: [
    // Angular modules
    CommonModule, 
    // Material design modules
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatListModule,
    // Custom modules
  ],
  templateUrl: './vertebral-levels-ad.component.html',
  styleUrl: './vertebral-levels-ad.component.css'
})

export class VertebralLevelsAdComponent {

  additionalInformationDict:any = null
  shouldUpdateAdditionalData:boolean = null

  nVertebralLevelLines:number = null

  // Image quality
  sliderIndex_imageQuality:number = null
  maxValue_imageQuality:number = GlobalVariables.additionalDataPopups.maxValue_imageQuality

  // Segmentation difficulty
  sliderIndex_segmentationDifficulty:number = null
  maxValue_segmentationDifficulty:number = GlobalVariables.additionalDataPopups.maxValue_segmentationDifficulty
  slideToggle_segmentationDifficulty:boolean = false 

  // Patient Orientation
  sliderIndex_patientOrientation:number = null
  maxValue_patientOrientation:number = GlobalVariables.additionalDataPopups.maxValue_patientOrientation

  // Artifact ranges
  maxValue_nArtifactRanges = GlobalVariables.additionalDataPopups.maxValue_nArtifactRanges
  sliderIndex_nArtifactRanges:number = null
  slideToggle_nArtifactRanges:boolean = false 

  // Overflow ranges
  maxValue_nOverflowRanges = GlobalVariables.additionalDataPopups.maxValue_nOverflowRanges
  sliderIndex_nOverflowRanges:number = null
  slideToggle_nOverflowRanges:boolean = false 


  // Vertebral level
  valueList_vertebralLevels = GlobalVariables.additionalDataPopups.vertebralLevels.vertebralLevelsNameList
  lowerSliderIndex_vertebralLevels:number = null
  upperSliderIndex_vertebralLevels:number = null
  sliderIndexes_vertebralLevels:number[] = [this.lowerSliderIndex_vertebralLevels, this.upperSliderIndex_vertebralLevels]

  // Intravenous contrast
  valueList_ivContrastLevel = GlobalVariables.additionalDataPopups.vertebralLevels.ivContrastLevelValueList
  sliderIndex_ivContrastLevel:number = null
  slideToggle_ivContrast:boolean = false 

  // Oral contrast
  slideToggle_oContrast:boolean = false
  selectedOptions_oContrast:number [] = [];
  listOptions_oContrast:string [] = this.languageService.Strings.additionalDataPopupsStrings.list_options_oContrast



  constructor(public languageService:LanguageService,
              public utilsService:UtilsService,
              public dialogRef: MatDialogRef<VertebralLevelsAdComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private sanitizer: DomSanitizer
            ){

    this.additionalInformationDict = this.utilsService.deepCopyDict(data.additionalInformationDict)
    this.shouldUpdateAdditionalData = false
  }



  ngOnInit(): void {
    // Initialize variables
    //    Vertebral level
    if (this.additionalInformationDict['vertebralLevels'] && // Check if vertebralLevels exists
    Array.isArray(this.additionalInformationDict['vertebralLevels']) && // Ensure it's an array
    this.additionalInformationDict['vertebralLevels'].length >= 2 // Ensure it has at least 2 elements
    ) {
      this.sliderIndexes_vertebralLevels = this.additionalInformationDict['vertebralLevels'];
      this.lowerSliderIndex_vertebralLevels = this.sliderIndexes_vertebralLevels[0];
      this.upperSliderIndex_vertebralLevels = this.sliderIndexes_vertebralLevels[1];
    } else { // Handle the invalid case (e.g., assign default values or throw an error)
      this.lowerSliderIndex_vertebralLevels = null;
      this.upperSliderIndex_vertebralLevels = null;
      this.sliderIndexes_vertebralLevels = [this.lowerSliderIndex_vertebralLevels, this.upperSliderIndex_vertebralLevels]
      this.additionalInformationDict['vertebralLevels'] = this.sliderIndexes_vertebralLevels;
    }   
    //    Image quality
    if(this.additionalInformationDict['imageQuality'] !== null && this.additionalInformationDict['imageQuality'] != undefined){
      this.sliderIndex_imageQuality = this.additionalInformationDict['imageQuality']
    }
    //    Segmentation difficulty
    if(this.additionalInformationDict['entireLumbarRange']){
      this.slideToggle_segmentationDifficulty = true
      this.sliderIndex_segmentationDifficulty = this.additionalInformationDict['segmentationDifficulty']
    } else {
      this.slideToggle_segmentationDifficulty = false
      this.sliderIndex_segmentationDifficulty = null
      this.additionalInformationDict['entireLumbarRange'] = this.slideToggle_segmentationDifficulty;
      this.additionalInformationDict['segmentationDifficulty'] = this.sliderIndex_segmentationDifficulty;
    } 

    //    Patient orierntation
    if(this.additionalInformationDict['patientOrientation'] !== null && this.additionalInformationDict['patientOrientation'] != undefined){
      this.sliderIndex_patientOrientation = this.additionalInformationDict['patientOrientation']
    }
    //    Articat ranges
    if(this.additionalInformationDict['artifacts']){
      this.slideToggle_nArtifactRanges = true
      this.sliderIndex_nArtifactRanges = this.additionalInformationDict['nArtifactRanges']
    } else {
      this.slideToggle_nArtifactRanges = false
      this.sliderIndex_nArtifactRanges = null
      this.additionalInformationDict['artifacts'] = this.slideToggle_nArtifactRanges;
      this.additionalInformationDict['nArtifactRanges'] = this.sliderIndex_nArtifactRanges;
    } 
    //    Overflow ranges
    if(this.additionalInformationDict['overflow']){
      this.slideToggle_nOverflowRanges = true
      this.sliderIndex_nOverflowRanges = this.additionalInformationDict['nOverflowRanges']
    } else {
      this.slideToggle_nOverflowRanges = false
      this.sliderIndex_nOverflowRanges = null
      this.additionalInformationDict['overflow'] = this.slideToggle_nOverflowRanges;
      this.additionalInformationDict['nOverflowRanges'] = this.sliderIndex_nOverflowRanges;
    } 
    //    Number of lines on position image according to vertebral levels
    if (this.additionalInformationDict['nVertebralLevelLines']){
      this.nVertebralLevelLines = this.additionalInformationDict['nVertebralLevelLines']
    } else {
      this.nVertebralLevelLines = null
      this.additionalInformationDict['nVertebralLevelLines'] = this.nVertebralLevelLines;
    } 
    //    Intravenous Contrast
    if(this.additionalInformationDict['ivContrast']){
      this.slideToggle_ivContrast = true
      this.sliderIndex_ivContrastLevel = this.additionalInformationDict['ivContrastLevel']
    } else {
      this.slideToggle_ivContrast = false
      this.sliderIndex_ivContrastLevel = null
      this.additionalInformationDict['ivContrast'] = this.slideToggle_ivContrast;
      this.additionalInformationDict['ivContrastLevel'] = this.sliderIndex_ivContrastLevel;
    } 
    //    Oral contrast
    if(this.additionalInformationDict['oContrast']){
      this.slideToggle_oContrast = true
      this.selectedOptions_oContrast = this.additionalInformationDict['oContrastLevels']
    } else {
      this.slideToggle_oContrast = false
      this.selectedOptions_oContrast = []
      this.additionalInformationDict['oContrast'] = this.slideToggle_oContrast;
      this.additionalInformationDict['oContrastLevels'] = this.selectedOptions_oContrast;
    }
  }


  // ----- Button actions ----- //


  exitButtonClicked(){
    // Manage unsaved changes
    let unsavedChanges = this.evaluateUnsavedChanges()
    if(!unsavedChanges){
      this.dialogRef.close({shouldUpdateAdditionalData:this.shouldUpdateAdditionalData, additionalInformationDict:this.additionalInformationDict})
    }else{
      this.utilsService.displayDecisionPopupComponent(
        this.languageService.Strings.popups.title_saveChanges,
        this.languageService.Strings.popups.text_saveChanges,
        this.shouldSaveBeforeExiting.bind(this)
      )
    }
  }

  shouldSaveBeforeExiting(shouldSave){
    if(shouldSave) this.saveChanges()
    this.dialogRef.close({shouldUpdateAdditionalData:this.shouldUpdateAdditionalData, additionalInformationDict:this.additionalInformationDict})
  }

  saveButtonClicked(){
    this.saveChanges()
    this.utilsService.displaySnackBar(this.languageService.Strings.feedbackStrings.successfullySaved);
  }


  keyboardPress(event){
    // Scape pressed (27) - Only trigered in keyboardUp
    if(event.keyCode == 27) {
      event.preventDefault();
      return false
    }
    return true
  }

  keyboardUp(event){
    if(event.keyCode == 27) {
      event.preventDefault();
      this.exitButtonClicked()
    }
    return true
  }

  
  // ---- Popup internal actions ----- //

  /*
  toggleChanged_ivContrast(event:any){
    this.slideToggle_ivContrast = this.slideToggle_ivContrast === false ? true : false
  }

  toggleChanged_oContrast(event:any){
    this.slideToggle_oContrast = this.slideToggle_oContrast === false ? true : false
  }

  toggleChanged_nArtifactRanges(event:any){
    this.slideToggle_nArtifactRanges = this.slideToggle_nArtifactRanges === false ? true : false
  }

  toggleChanged_nOverflowRanges(event:any){
    this.slideToggle_nOverflowRanges = this.slideToggle_nOverflowRanges === false ? true : false
  }
  */

  sliderChange_imageQuality(){
    //console.log(this.sliderIndex_imageQuality)
  }

  sliderChange_segmentationDifficulty(){
    //console.log(this.sliderIndex_imageQuality)
  }

  sliderChange_patientOrientation(){
    //console.log(this.sliderIndex_patientOrientation)
  }

  sliderChange_nArtifactRanges(){
    //console.log(this.sliderIndex_nArtifactRanges)
  }

  sliderChange_nOverflowRanges(){
    //console.log(this.sliderIndex_nOverflowRanges)
  }

  sliderChange_vertebralLevel(){
    this.sliderIndexes_vertebralLevels = [this.lowerSliderIndex_vertebralLevels, this.upperSliderIndex_vertebralLevels]
    // console.log(this.sliderIndexes_vertebralLevels)
  }
  sliderChange_ivContrastLevel(){
    //console.log(this.sliderIndex_ivContrastLevel)
  }
  selectionChange_oContrastLevel() {
    //console.log(this.selectedOptions_oContrast)
  }
  compareOptions = (option1: number, option2: number) => option1 === option2;


  getNArtifactRangesStrValue(){
    if(this.slideToggle_nArtifactRanges && this.sliderIndex_nArtifactRanges != null){
      return this.sliderIndex_nArtifactRanges.toString()
    }
    return '--- - ---'
  }

  getNOverflowRangesStrValue(){
    if(this.slideToggle_nOverflowRanges && this.sliderIndex_nOverflowRanges != null){
      return this.sliderIndex_nOverflowRanges.toString()
    }
    return '--- - ---'
  }

  getImageQualityStrValue(){
    if(this.sliderIndex_imageQuality != null && this.sliderIndex_imageQuality != undefined){
      return GlobalVariables.additionalDataPopups.imageQualityValueList[this.sliderIndex_imageQuality]
    }
    return '--- - ---'
  }

  getSegmentationDifficultyStrValue(){
    if(this.slideToggle_segmentationDifficulty != null && this.sliderIndex_segmentationDifficulty != null){
      return GlobalVariables.additionalDataPopups.segmentationDifficultyValueList[this.sliderIndex_segmentationDifficulty]
    }
    return '--- - ---'
  }

  getPatientOrientationStrValue(){
    if(this.sliderIndex_patientOrientation != null && this.sliderIndex_patientOrientation != undefined){
      return GlobalVariables.additionalDataPopups.patientOrientationValueList[this.sliderIndex_patientOrientation]
    }
    return '--- - ---'
  }

  getVertebralLevelStrValue(){
    if (this.sliderIndexes_vertebralLevels?.length === 2) {
      const lowerLevel = this.sliderIndexes_vertebralLevels[0] !== null 
        ? this.valueList_vertebralLevels[this.sliderIndexes_vertebralLevels[0]] 
        : null;
      const upperLevel = this.sliderIndexes_vertebralLevels[1] !== null 
        ? this.valueList_vertebralLevels[this.sliderIndexes_vertebralLevels[1]] 
        : null;

      if (lowerLevel && upperLevel) {
        return `${lowerLevel} - ${upperLevel}`;
      } else if (lowerLevel) {
        return `${lowerLevel} - ---`;
      } else if (upperLevel) {
        return `--- - ${upperLevel}`;
      }
    }
    return '--- - ---';
  }

  getIvContrastLevelStrValue(){
    if(this.slideToggle_ivContrast && this.sliderIndex_ivContrastLevel != null){
      let venousStr = `${this.valueList_ivContrastLevel[this.sliderIndex_ivContrastLevel][0]*100}%  ${this.languageService.Strings.additionalDataPopupsStrings.value_venous_ivContrast}`
      let arterialStr = `${this.valueList_ivContrastLevel[this.sliderIndex_ivContrastLevel][1]*100}%  ${this.languageService.Strings.additionalDataPopupsStrings.value_arterial_ivContrast}`
      return `${venousStr} - ${arterialStr}`
    }
    return '---'
  }

  getInfoIsValid() {
    if (
        // Ensure both values are not null and they are not the same
        (this.sliderIndexes_vertebralLevels?.length === 2 && 
         (this.sliderIndexes_vertebralLevels.some(value => value === null) || 
          this.sliderIndexes_vertebralLevels[0] === this.sliderIndexes_vertebralLevels[1])) || 
        // Ensure image quality is not null
        (this.sliderIndex_imageQuality == null) || 
        // Ensure segmentation difficulty is not null
        (this.slideToggle_segmentationDifficulty && this.sliderIndex_segmentationDifficulty == null) || 
        // Ensure patient orientation is not null
        (this.sliderIndex_patientOrientation == null) || 
        // There are artifacts, but the number of ranges is not specified
        (this.slideToggle_nArtifactRanges && this.sliderIndex_nArtifactRanges == null) || 
        // There is overflow, but the number of ranges is not specified
        (this.slideToggle_nOverflowRanges && this.sliderIndex_nOverflowRanges == null) || 
        // There is intravenous contrast, but the level is not specified
        (this.slideToggle_ivContrast && this.sliderIndex_ivContrastLevel == null) || 
        // There is oral contrast, but the level is not specified
        (this.slideToggle_oContrast && this.selectedOptions_oContrast.length <= 0)
    ) { 
      return false;
    }
    return true;
  }


  // ---- Popup global actions ---- //


  saveChanges(){
    // Vertebral level
    this.additionalInformationDict['vertebralLevels'] = this.sliderIndexes_vertebralLevels
    // Image quality
    this.additionalInformationDict['imageQuality'] = this.sliderIndex_imageQuality
    // Segmentation difficulty
    this.additionalInformationDict['entireLumbarRange'] = this.slideToggle_segmentationDifficulty
    if(this.slideToggle_segmentationDifficulty) this.additionalInformationDict['segmentationDifficulty'] = this.sliderIndex_segmentationDifficulty
    else if(!this.additionalInformationDict['entireLumbarRange']) delete this.additionalInformationDict['segmentationDifficulty']
    // Patient orientation
    this.additionalInformationDict['patientOrientation'] = this.sliderIndex_patientOrientation
    // N artifact ranges
    this.additionalInformationDict['artifacts'] = this.slideToggle_nArtifactRanges
    if(this.slideToggle_nArtifactRanges) this.additionalInformationDict['nArtifactRanges'] = this.sliderIndex_nArtifactRanges
    else if(!this.additionalInformationDict['artifacts']) delete this.additionalInformationDict['nArtifactRanges']
    // N overflow ranges
    this.additionalInformationDict['overflow'] = this.slideToggle_nOverflowRanges
    if(this.slideToggle_nOverflowRanges) this.additionalInformationDict['nOverflowRanges'] = this.sliderIndex_nOverflowRanges
    else if(!this.additionalInformationDict['overflow']) delete this.additionalInformationDict['nOverflowRanges']
    // Intravenous contrast and intravenous contrast level
    this.additionalInformationDict['ivContrast'] = this.slideToggle_ivContrast
    if(this.slideToggle_ivContrast) this.additionalInformationDict['ivContrastLevel'] = this.sliderIndex_ivContrastLevel
    else if(!this.additionalInformationDict['ivContrastLevel']) delete this.additionalInformationDict['ivContrastLevel']
    // Oral contrast and oral contrast level
    this.additionalInformationDict['oContrast'] = this.slideToggle_oContrast
    if(this.slideToggle_oContrast) this.additionalInformationDict['oContrastLevels'] = this.selectedOptions_oContrast
    else if(!this.additionalInformationDict['oContrastLevels']) delete this.additionalInformationDict['oContrastLevels']
    // Get the number of lines on position image
    if (this.lowerSliderIndex_vertebralLevels != null && this.upperSliderIndex_vertebralLevels != null)
      this.nVertebralLevelLines = (this.upperSliderIndex_vertebralLevels - this.lowerSliderIndex_vertebralLevels) + 1
    this.additionalInformationDict['nVertebralLevelLines'] = this.nVertebralLevelLines
    // Notify that there are updates
    this.shouldUpdateAdditionalData = true
  }

  evaluateUnsavedChanges() {
    const vertebralLevels = this.additionalInformationDict['vertebralLevels'] 
    const imageQuality = this.additionalInformationDict['imageQuality']
    const entireLumbarRange = this.additionalInformationDict['entireLumbarRange']
    const segmentationDifficulty = this.additionalInformationDict['segmentationDifficulty']
    const patientOrientation = this.additionalInformationDict['patientOrientation']
    const artifacts = this.additionalInformationDict['artifacts']
    const nArtifactRanges = this.additionalInformationDict['nArtifactRanges']
    const overflow = this.additionalInformationDict['overflow']
    const nOverflowRanges = this.additionalInformationDict['nOverflowRanges']
    const ivContrast = this.additionalInformationDict['ivContrast'] 
    const ivContrastLevel = this.additionalInformationDict['ivContrastLevel']
    const oContrast = this.additionalInformationDict['oContrast']
    const oContrastLevels = this.additionalInformationDict['oContrastLevels']
    
    // Vertebral Levels
    if (!Array.isArray(vertebralLevels) || vertebralLevels.length < 2 || 
        this.sliderIndexes_vertebralLevels[0] !== vertebralLevels[0] || 
        this.sliderIndexes_vertebralLevels[1] !== vertebralLevels[1]) {
      return true;
    }
    // Image quality
    if (this.sliderIndex_imageQuality !== imageQuality){
      return true
    }
    // Segmentation difficulty
    if (this.slideToggle_segmentationDifficulty ? (!entireLumbarRange || this.sliderIndex_segmentationDifficulty !== segmentationDifficulty) : entireLumbarRange) {
      return true;
    }
    // Patient orientation
    if (this.sliderIndex_patientOrientation !== patientOrientation){
      return true
    }
    // N artifact ranges
    if (this.slideToggle_nArtifactRanges ? (!artifacts || this.sliderIndex_nArtifactRanges !== nArtifactRanges) : artifacts) {
      return true;
    }
    // N overflow ranges
    if (this.slideToggle_nOverflowRanges ? (!overflow || this.sliderIndex_nOverflowRanges !== nOverflowRanges) : overflow) {
      return true;
    }
    // Intravenous Contrast
    if (this.slideToggle_ivContrast ? (!ivContrast || this.sliderIndex_ivContrastLevel !== ivContrastLevel) : ivContrast) {
      return true;
    }
    // Oral Contrast
    if (this.slideToggle_oContrast ? (!oContrast || this.selectedOptions_oContrast !== oContrastLevels) : oContrast) {
      return true;
    }
    return false; // No unsaved changes
  }
  
  

}